const replacedText = {
  '&lt;': '<',
  '<br />': '\n',
};

export default string => {
  return String(string).replace(/<br\s*\/?>|&lt;/g, s => replacedText[s]);
};



// WEBPACK FOOTER //
// ./src/utils/prettifyText.js